import { render, staticRenderFns } from "./RankColumnScore.vue?vue&type=template&id=c95a4d08&scoped=true&"
import script from "./RankColumnScore.vue?vue&type=script&lang=ts&"
export * from "./RankColumnScore.vue?vue&type=script&lang=ts&"
import style0 from "./RankColumnScore.vue?vue&type=style&index=0&id=c95a4d08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95a4d08",
  null
  
)

export default component.exports